import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "asset-groups-page" }
const _hoisted_2 = { class: "asset-groups-header" }
const _hoisted_3 = { class: "mb-1" }
const _hoisted_4 = { class: "text-muted small" }
const _hoisted_5 = { class: "d-flex align-items-center gap-3" }
const _hoisted_6 = { class: "tabs" }
const _hoisted_7 = { class: "tab-content mt-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-3"
}
const _hoisted_10 = {
  key: 1,
  class: "d-flex align-items-center gap-3 py-3"
}
const _hoisted_11 = { class: "data-grid-card" }
const _hoisted_12 = { class: "action-buttons" }
const _hoisted_13 = ["title", "onClick"]
const _hoisted_14 = ["title", "onClick"]
const _hoisted_15 = ["title", "onClick"]
const _hoisted_16 = {
  key: 0,
  class: "text-center text-muted py-3"
}
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_AssetHierarchyView = _resolveComponent("AssetHierarchyView")!
  const _component_AssetGroupFormModal = _resolveComponent("AssetGroupFormModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('aside.menu.pages.assetGroups')), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('components.assetGroups.subtitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.activeTab === 'list' && _ctx.canCreate)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary d-flex align-items-center gap-2",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args)))
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetGroups.addButton')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: _normalizeClass(["tab-btn", { active: _ctx.activeTab === 'list' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'list'))
          }, _toDisplayString(_ctx.$t('components.assetGroups.listTab')), 3),
          _createElementVNode("button", {
            class: _normalizeClass(["tab-btn", { active: _ctx.activeTab === 'hierarchy' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'hierarchy'))
          }, _toDisplayString(_ctx.$t('components.assetGroups.hierarchyTab')), 3)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.activeTab === 'list')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.listError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.listError), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.listLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", {
                    class: "spinner-border text-primary",
                    role: "status"
                  }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetGroups.loading')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_DxDataGrid, {
                ref: "gridRef",
                class: "ag-grid",
                "data-source": _ctx.dataSource,
                "remote-operations": true,
                "hover-state-enabled": true,
                "column-auto-width": false,
                "show-borders": true,
                "row-alternation-enabled": true,
                "column-hiding-enabled": true,
                "word-wrap-enabled": true
              }, {
                "actions-template": _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_12, [
                    (!_ctx.isReadOnly)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-sm btn-outline-primary",
                          title: _ctx.$t('components.assetGroups.actions.edit'),
                          onClick: ($event: any) => (_ctx.openEditModal(data.data))
                        }, [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
                        ]))], 8, _hoisted_13))
                      : _createCommentVNode("", true),
                    (_ctx.canEdit)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "btn btn-sm btn-outline-danger",
                          title: _ctx.$t('components.assetGroups.actions.delete'),
                          onClick: ($event: any) => (_ctx.confirmDelete(data.data))
                        }, [...(_cache[7] || (_cache[7] = [
                          _createElementVNode("i", { class: "bi bi-trash" }, null, -1)
                        ]))], 8, _hoisted_14))
                      : _createCommentVNode("", true),
                    (_ctx.isReadOnly)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          class: "btn btn-sm btn-outline-secondary",
                          title: _ctx.$t('components.assetGroups.actions.view'),
                          onClick: ($event: any) => (_ctx.openViewModal(data.data))
                        }, [...(_cache[8] || (_cache[8] = [
                          _createElementVNode("i", { class: "bi bi-eye" }, null, -1)
                        ]))], 8, _hoisted_15))
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_DxHeaderFilter, { visible: true }),
                  _createVNode(_component_DxFilterRow, { visible: true }),
                  _createVNode(_component_DxPaging, { "page-size": 20 }),
                  _createVNode(_component_DxPager, {
                    "allowed-page-sizes": [10, 20, 50],
                    "show-info": true,
                    "show-page-size-selector": true,
                    "show-navigation-buttons": true
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "name",
                    caption: _ctx.$t('components.assetGroups.columns.name'),
                    "min-width": 180
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "hierarchyName",
                    caption: _ctx.$t('components.assetGroups.columns.level'),
                    "min-width": 140,
                    "allow-filtering": false,
                    "hiding-priority": 3
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "parentName",
                    caption: _ctx.$t('components.assetGroups.columns.parent'),
                    "min-width": 160,
                    "allow-filtering": false,
                    "hiding-priority": 2
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "depth",
                    caption: _ctx.$t('components.assetGroups.columns.depth'),
                    alignment: "center",
                    width: "100",
                    "allow-filtering": false,
                    "hiding-priority": 4
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "usersCount",
                    caption: _ctx.$t('components.assetGroups.columns.users'),
                    alignment: "center",
                    width: "120",
                    "allow-filtering": false,
                    "hiding-priority": 1
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "assetsCount",
                    caption: _ctx.$t('components.assetGroups.columns.assets'),
                    alignment: "center",
                    width: "120",
                    "allow-filtering": false,
                    "hiding-priority": 0
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "vehiclesCount",
                    caption: _ctx.$t('components.assetGroups.columns.vehicles'),
                    alignment: "center",
                    width: "120",
                    "allow-filtering": false,
                    "hiding-priority": 1
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    caption: _ctx.$t('components.assetGroups.columns.actions'),
                    width: 150,
                    "allow-filtering": false,
                    "allow-sorting": false,
                    "cell-template": "actions-template"
                  }, null, 8, ["caption"])
                ]),
                _: 1
              }, 8, ["data-source"]),
              (_ctx.isGridEmpty)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t('components.assetGroups.empty')), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_AssetHierarchyView, { ref: "hierarchyView" }, null, 512)
          ]))
    ]),
    _createVNode(_component_AssetGroupFormModal, {
      ref: "formModal",
      onSaved: _ctx.handleSaved
    }, null, 8, ["onSaved"])
  ]))
}